import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/Home'
import AdStyle from '@/pages/adstyle/AdStyle'
import Advantage from '@/pages/advantage/Advantage'
import Example from '@/pages/example/Example'
import AboutUs from '@/pages/aboutUs/AboutUs'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home'
    }, {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        title: '品牌推广平台-马拉松品牌推广-跑团邦'
      }
    }, {
      path: '/home/ad-style',
      name: 'AdStyle',
      component: AdStyle,
      meta: {
        title: '马拉松照片广告形式-跑团邦'
      }
    }, {
      path: '/home/advantage',
      name: 'Advantage',
      component: Advantage,
      meta: {
        title: '我们的优势-跑团邦'
      }
    }, {
      path: '/home/example',
      name: 'Example',
      component: Example,
      meta: {
        title: '客户案例-跑团邦'
      }
    }, {
      path: '/home/about-us',
      name: 'AboutUs',
      component: AboutUs,
      meta: {
        title: '了解我们-跑团邦'
      }
    },{ 
      path: '*', 
      component: Home 
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js